import { render } from "./ButtonPrimary.vue?vue&type=template&id=30aa0fb2&scoped=true&bindings={\"outline\":\"props\",\"disabled\":\"props\",\"ml\":\"props\",\"mr\":\"props\"}"
import script from "./ButtonPrimary.vue?vue&type=script&lang=js"
export * from "./ButtonPrimary.vue?vue&type=script&lang=js"

import "./ButtonPrimary.vue?vue&type=style&index=0&id=30aa0fb2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30aa0fb2"

export default script